import HttpClient from "../helpers/HttpClient"
import {isError} from "../helpers/Error"
import Account, {AccountDto} from "./account"
import {AppContext} from "@lightspeed-invoicing/core-client/frontend"
import { PatchPayload } from "./types"

class Service {
    httpClient: HttpClient<Account, AccountDto> = new HttpClient<Account, AccountDto>(Account)

    async get(accountId: string): Promise<Account> {
        const res = await this.httpClient.get(`/accounts/${accountId}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return (res as Account)
    }

    async patch(payload: PatchPayload){
        try {
            const res = await this.httpClient.patch("/accounts/account-details", payload)
            if (isError(res)) {
                throw new Error(res.message)
            }
            const account = res.getDto()
            AppContext.setAccount(account)
            return account
        } catch (err) {
            throw new Error("Error patching accounts/account-details")
        }
    }

}

const instance = new Service()
export default instance


// WEBPACK FOOTER //
// ./src/state/account/service.ts